/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        // Lazy Load for images and background images
        $(document).ready(function ($) {
              $("img.lazy").lazyload(
                  { data_attribute: "orig", effect: "fadeIn" 
              });
              $("section.lazy").lazyload({
                  effect : "fadeIn"
              });
              $("div.lazy").lazyload({
                  effect : "fadeIn"
              });
              $('.woocommerce-product-gallery').flexslider({
                maxItems: 4,
              });
              

          });
        $('.gallery-carousel').owlCarousel({
            responsive : {
              0 : {
                items: 1
              },
              768 : {
                items: 3
              }
            },
            lazyLoad:true,
            loop:true,
            margin:10,
            autoplay: false,
            dots: true,
            nav: false,
            });
        $('.owl-carousel').owlCarousel({
            items:1,
            lazyLoad:true,
            loop:false,
            margin:10,
            dots: true,
            nav: true,
            navText: ["<i class='fa fa-angle-left'>","<i class='fa fa-angle-right'>"] // Sets what appears in the nav boxes
        });

        $(".flex-control-nav").flexslider({
          maxItems: 4
        });
        
        // Waypoints for scroll animations
        
        /* $('.choose-options-div').waypoint(function() {
            $( ".woocommerce-product-gallery" ).toggleClass( "fixed-gallery" );
        }, {
            offset: '50%'
        });
        $('.woocommerce-Tabs-panel').waypoint(function() {
            $( ".woocommerce-product-gallery" ).toggleClass( "fixed-gallery" );
        }, {
            offset: '85%'
        });
        $('#fade').waypoint(function() {
            $( "#fade" ).toggleClass( "fadeIn" );
        }, {
            offset: '70%'
        }); */
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
